<ng-template #dialog>
	<form [formGroup]="declineOrderForm">
		<nb-card>
			<nb-card-body class="decline-dialog">
				<h2>Are you sure you would like to reject this application?</h2>

				<div class="row-wrapper reason-row form-group">
					<div class="col-md-12">
						<label>ENTER YOUR REASON</label>
						<textarea formControlName="decliningReason" class="reason form-control" name="decline-reason" nbInput fullWidth placeholder="Place your text" required [(ngModel)]="reason"
								  [disabled]="declineButtonClicked" [readOnly]="declineButtonClicked"></textarea>
						@if (!(declineOrderForm.controls['decliningReason'].valid || isDeclineReasonControlPristine())) {
							<div class="validation-message"
							>{{ getDeclineFormErrors() }}
							</div>
						}
					</div>
				</div>
				<div class="row-wrapper buttons-row">
					<div class="col-md-12">
						<button id="cancel-button" nbButton outline status="danger" [disabled]="buttonClicked()" (click)="closeDeclineDialog()">CANCEL</button>
						<button id="decline-offer-button" nbButton status="danger" [disabled]="!(declineOrderForm.valid || isFormPristine()) || buttonClicked() || emptyReason()"
								(click)="emitDeclinedClicked(reason)">DECLINE
						</button>
					</div>
				</div>
			</nb-card-body>
		</nb-card>
	</form>
</ng-template>
